<template>
    <div class="container">
        <div class="box search-form">
            <form action="" aria-label="Job search filters">
                <h1 class="title is-3">Search</h1>
                <div class="fixed-grid has-2-cols-mobile has-3-cols-tablet has-4-cols-desktop">
                    <div class="grid">
                        <div
                             v-for="field in searchFields"
                             :key="field.name"
                             class="field">
                            <label
                                   class="label"
                                   :for="field.repr">{{ field.name }}</label>
                            <div class="control">
                                <input
                                       :id="field.repr"
                                       v-model="field.value"
                                       type="text"
                                       class="input" />
                            </div>
                        </div>
                        <div class="field">
                            <label
                                   for="day_range"
                                   class="label">{{ dateRange.name }}</label>
                            <div class="select">
                                <select
                                        v-model="dateRange.value"
                                        name="days"
                                        id="day_range">
                                    <option value="">Any time</option>
                                    <option value="1">One Day</option>
                                    <option value="7">One Week</option>
                                    <option value="30">One Month</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                     ref="submitBtn"
                     class="button is-primary is-fullwidth mt-4"
                     type="button"
                     @click="search()"
                     :disabled="loading"
                     :class="{ 'is-loading': loading }">
                    Submit
                </button>
            </form>
        </div>
    </div>
    <section class="is-large">
        <div class="container">
            <div v-if="error" class="notification is-danger is-light">
                <button class="delete" @click="error = null; $nextTick(() => submitBtn.focus())"></button>
                Failed to load jobs. Please try again.
            </div>
            <div v-if="loading && jobs.length === 0" class="has-text-centered p-6 loading-state">
                <span class="button is-loading is-large is-ghost"></span>
                <p class="mt-2">Loading jobs...</p>
            </div>
            <ListItem v-else :jobs="jobs"></ListItem>
        </div>
    </section>
    <Pagination
                :links="links"
                :content="content"
                @get-jobs="search"></Pagination>
</template>
<script setup lang="ts">
import { reactive, ref, onMounted } from "vue"
import { assign_job_to_user, get_title_str } from "../utils"
import { useJobList } from "../composables/useJobList"
import { API_BASE } from "../config"
import ListItem from "./ListItem.vue"
import Pagination from "./Pagination.vue"

const submitBtn = ref<HTMLButtonElement | null>(null)

const { jobs, links, content, loading, error, getJobs } = useJobList({
  baseUrl: `${API_BASE}/job_listings.json/`,
  routeName: "job-search",
})

const searchFields = reactive([
  { name: "Job Title", repr: "jobtitle__icontains", value: "" },
  { name: get_title_str("Description"), repr: "search", value: "" },
  { name: get_title_str("Location"), repr: "location__icontains", value: "" },
  { name: get_title_str("Organization"), repr: "organization__icontains", value: "" },
])

const dateRange = reactive({
  name: get_title_str("date range"),
  repr: "formatted_post_date",
  value: "",
})

function search(page: number | null = null) {
  const params: Record<string, any> = {}
  for (const field of [...searchFields, dateRange]) {
    if (field.value) {
      params[field.repr] = field.value
    }
  }
  getJobs(page, params)
}

function selectJobToMatch(job: any) {
  job.relevant = true
  assign_job_to_user(job)
}

onMounted(() => search())
</script>
